import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  margin?: string;
}

export const Skeleton = styled.div<SkeletonProps>`
  display: inline-block;
  width: ${(p) => p.width || '100%'};
  height: ${(p) => p.height || '1rem'};
  border-radius: ${(p) => p.borderRadius || p.theme.radius};
  margin: ${(p) => p.margin || '0'};
  background-color: ${(p) => p.theme.lightGray};
  background-image: linear-gradient(
    90deg,
    ${(p) => p.theme.lightGray} 0px,
    ${(p) => p.theme.surfaceAlt} 40px,
    ${(p) => p.theme.lightGray} 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.5s infinite linear;
`;

export default Skeleton;
